// extracted by mini-css-extract-plugin
export default {"menuItem":"MenuButton_menuItem__zRVYG","center":"MenuButton_center__3fhtK","between":"MenuButton_between__8h-YS"};